<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";

const emit = defineEmits(['close', 'back']);
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      class="tw-z-[100]"
      modal-class="tw-w-[698px]"
      @close="emit('close')"
    >
      <div class="tw-px-8 tw-pb-8 tw-flex tw-gap-8 tw-text-neutral-900">
        <div class="tw-mt-4">
          <KitIcon
            class="tw-w-25"
            state="sad"
          />
        </div>
        <div class="tw-flex tw-flex-col">
          <h2 class="tw-text-3.25xl tw-font-bold tw-mb-6">
            Caution
          </h2>
          <div class="tw-text-base tw-mb-16">
            If you close this window without submitting your feedback, all your changes will be lost.  Do you wish to continue?
          </div>
          <div class="tw-flex tw-justify-end tw-items-center tw-gap-3">
            <DefaultButton @click="emit('back')">
              Go Back
            </DefaultButton>
            <DefaultButton
              variant="primary-inverted"
              @click="emit('close')"
            >
              Close Without Saving
            </DefaultButton>
          </div>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>
